export default __webpack_public_path__ + "static/media/ai-launchpad.32897b75.svg";